import { render, staticRenderFns } from "./StudentThesis.vue?vue&type=template&id=65c53b30&scoped=true"
import script from "./StudentThesis.vue?vue&type=script&lang=js"
export * from "./StudentThesis.vue?vue&type=script&lang=js"
import style0 from "./StudentThesis.vue?vue&type=style&index=0&id=65c53b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c53b30",
  null
  
)

export default component.exports